import { styled } from '../';

export const Opacity =
  styled('div') <
  { opacity: number } >
  `
  opacity: ${p => (p.opacity ? p.opacity : 0.5)};
  display: inherit;
`;
